"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _is_before = _interopRequireDefault(require("date-fns/is_before"));

var _sub_days = _interopRequireDefault(require("date-fns/sub_days"));

var _sub_months = _interopRequireDefault(require("date-fns/sub_months"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _propValidators = require("../utils/propValidators");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function formatDateForMode(date, mode) {
  if (mode === 'month') {
    return {
      ariaLabel: (0, _format["default"])(date, 'MMMM D, YYYY'),
      content: (0, _format["default"])(date, 'D')
    };
  }

  return {
    ariaLabel: (0, _format["default"])(date, 'MMMM YYYY'),
    content: (0, _format["default"])(date, 'MMM')
  };
}

function isPast(date, mode) {
  if (date) {
    if (mode === 'month') {
      return (0, _is_before["default"])(date, (0, _sub_days["default"])(new Date(), 1));
    }

    return (0, _is_before["default"])(date, (0, _sub_months["default"])(new Date(), 1));
  }

  return false;
}

function getLabel(_ref) {
  var due = _ref.due,
      late = _ref.late;

  if (late) {
    return 'Late';
  }

  if (due) {
    return 'Due';
  }

  return '';
}

var CalendarCell = function CalendarCell(_ref2) {
  var date = _ref2.date,
      disabled = _ref2.disabled,
      due = _ref2.due,
      late = _ref2.late,
      mode = _ref2.mode,
      onSelect = _ref2.onSelect,
      unavailable = _ref2.unavailable,
      selected = _ref2.selected;
  var ariaLabel;
  var content;

  if (date) {
    var _formatDateForMode = formatDateForMode(date, mode);

    ariaLabel = _formatDateForMode.ariaLabel;
    content = _formatDateForMode.content;
  }

  var cellClasses = (0, _classnames["default"])('grv-calendar__body-cell', {
    'grv-calendar__body--disabled': disabled,
    'grv-calendar__body--past': isPast(date, mode),
    'grv-calendar__body--unavailable': unavailable
  });
  var contentClasses = (0, _classnames["default"])('grv-calendar__body-cell-content', {
    'grv-calendar__body--due': due,
    'grv-calendar__body--late': late,
    'grv-calendar__body--selected': selected
  });
  var label = getLabel({
    due: due,
    late: late
  });
  var selectHandler = !(disabled || unavailable) ? function (event) {
    return onSelect(date, event);
  } : undefined;
  return /*#__PURE__*/_react["default"].createElement("td", {
    "aria-label": ariaLabel,
    className: cellClasses,
    onClick: selectHandler,
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter') {
        selectHandler(event);
      }
    },
    role: "gridcell",
    style: {
      paddingBottom: '7.14286%',
      paddingTop: '7.14286%',
      width: '14.2857%'
    },
    tabIndex: !(disabled || unavailable) ? 0 : -1
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: contentClasses
  }, content, label ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "grv-calendar__body-cell-label"
  }, label) : null));
};

var propTypes = {
  date: _propValidators.dateType,
  disabled: _propTypes["default"].bool,
  due: _propTypes["default"].bool,
  late: _propTypes["default"].bool,
  mode: _propTypes["default"].oneOf(['month', 'year']).isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  selected: _propTypes["default"].bool,
  unavailable: _propTypes["default"].bool
};
var defaultProps = {
  disabled: false,
  due: false,
  late: false,
  selected: false,
  unavailable: false
};
CalendarCell.propTypes = propTypes;
CalendarCell.defaultProps = defaultProps;
var _default = CalendarCell;
exports["default"] = _default;